<!-- Brand row. The logo/wordmark navigates home; the chevron collapses the rail.
     They are siblings (not nested) so the toggle can never trigger the home
     navigation. -->
<div class="brand-header" [class.brand-header--collapsed]="collapsed()">
  <div class="brand-link" routerLink="home">
    <img [src]="logoSrc()" class="brand-icon" alt="domainGRC" />
    @if (!collapsed()) {
      <span class="brand-text"><span class="brand-text-domain">domain</span><span class="brand-text-grc">GRC</span></span>
    }
  </div>
  <button
    type="button"
    class="collapse-toggle"
    (click)="toggleCollapsed()"
    [attr.aria-label]="collapsed() ? 'Expand navigation' : 'Collapse navigation'"
    [attr.aria-expanded]="!collapsed()"
    [attr.title]="collapsed() ? 'Expand navigation' : 'Collapse navigation'"
  >
    <mat-icon class="material-symbols-rounded">{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </button>
</div>
<mat-list data-cy="sideNavList" role="list">
  <!-- Groups are declared as templates and rendered below in resolved-layout
       order (orderedGroups). Real DOM order — not CSS `order` — so keyboard
       and screen-reader traversal always matches the visual order. -->

  <ng-template #grpDefault>
    <div class="menu-group">
      @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'DEFAULT'){
      <mat-list-item role="listitem">
        <div>
          <button
            mat-button
            data-cy="content"
            [routerLink]="item.link"
            routerLinkActive="active-route"
            [attr.title]="collapsed() ? item.text : null"
          >
            <div class="link-image">
              <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
              <span class="link-text">{{ item.text }}</span>
            </div>
          </button>
        </div>
      </mat-list-item>
      } }
    </div>
  </ng-template>

  <ng-template #grpAi>
    <div class="menu-group">
      @if (!menuVisibility()['ai'].hiddenGroup) {
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
      <mat-list-item
        role="listitem"
        (click)="toggleVisibility('ai')"
        class="compliance-parent"
      >
        @if (collapsed()) {
        <div class="align-items group-icon" title="ai">
          <mat-icon class="icon material-symbols-rounded">{{ groupIcon('ai') }}</mat-icon>
        </div>
        } @else {
        <div class="align-items">
          <span class="parent-width">ai</span>
          <mat-icon
            class="expand-button"
            [ngClass]="{ rotated: menuVisibility()['ai'].menu }"
            >expand_more</mat-icon
          >
        </div>
        }
      </mat-list-item>
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('ai') }"
        [style.display]="submenuVisible('ai') ? 'block' : 'none'"
      >
        @if (!menuVisibility()['ai'].chatHidden) {
          <mat-list-item role="listitem">
            <div>
              <button
                mat-button
                routerLink="/ai/chat"
                [queryParams]="newChatQueryParams"
                queryParamsHandling="merge"
                class="chat-toggle-btn"
                routerLinkActive="active-route"
                [attr.title]="collapsed() ? 'New Chat' : null"
              >
                <div class="link-image">
                  <mat-icon class="icon material-symbols-rounded">add_comment</mat-icon>
                  <span class="link-text">New Chat</span>
                </div>
              </button>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div>
              <button
                mat-button
                routerLink="/ai/history"
                queryParamsHandling="preserve"
                routerLinkActive="active-route"
                [attr.title]="collapsed() ? 'History' : null"
              >
                <div class="link-image">
                  <mat-icon class="icon material-symbols-rounded">history</mat-icon>
                  <span class="link-text">History</span>
                </div>
              </button>
            </div>
          </mat-list-item>
        }
        @if (!menuVisibility()['ai'].knowledgeHidden) {
          <mat-list-item role="listitem">
            <div>
              <button
                mat-button
                routerLink="/ai/knowledge"
                queryParamsHandling="preserve"
                routerLinkActive="active-route"
                [attr.title]="collapsed() ? 'Knowledge Base' : null"
              >
                <div class="link-image">
                  <mat-icon class="icon material-symbols-rounded">auto_stories</mat-icon>
                  <span class="link-text">Knowledge Base</span>
                </div>
              </button>
            </div>
          </mat-list-item>
        }
      </div>
      }
    </div>
  </ng-template>

  <ng-template #grpMyDomain>
    <div class="menu-group">
      <!-- Separator above the header, matching every other group. myDomain's
           header always renders, so this is unconditional. -->
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
      <mat-list-item
        role="listitem"
        (click)="toggleVisibility('domain')"
        class="compliance-parent"
      >
        @if (collapsed()) {
        <div class="align-items group-icon" title="myDomain">
          <mat-icon class="icon material-symbols-rounded">{{ groupIcon('myDomain') }}</mat-icon>
        </div>
        } @else {
        <div class="align-items">
          <span class="parent-width">myDomain</span>
          <mat-icon
            class="expand-button"
            [ngClass]="{ rotated: menuVisibility()['domain'].menu }"
            >expand_more</mat-icon
          >
        </div>
        }
      </mat-list-item>
      @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'COMPLIANCE'){
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('domain') }"
        [style.display]="submenuVisible('domain') ? 'block' : 'none'"
      >
        <mat-list-item role="listitem">
          <div>
            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image">
                <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
      </div>
      } } @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'MANAGER'){
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('domain') }"
        [style.display]="submenuVisible('domain') ? 'block' : 'none'"
      >
        <mat-list-item role="listitem">
          <div>
            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image">
                <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
      </div>
      }}
    </div>
  </ng-template>

  <ng-template #grpAssetMgr>
    <div class="menu-group">
      @if (!menuVisibility()['asset'].hiddenGroup) {
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
        <mat-list-item
          role="listitem"
          (click)="toggleVisibility('asset')"
          class="compliance-parent"
        >
          @if (collapsed()) {
          <div class="align-items group-icon" title="assetMGR">
            <mat-icon class="icon material-symbols-rounded">{{ groupIcon('assetMGR') }}</mat-icon>
          </div>
          } @else {
          <div class="align-items">
            <span class="parent-width">assetMGR</span>
            <mat-icon
              class="expand-button"
              [ngClass]="{ rotated: menuVisibility()['asset'].menu }"
              >expand_more</mat-icon
            >
          </div>
          }
        </mat-list-item>
      }
      @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'ASSET'){
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('asset') }"
        [style.display]="submenuVisible('asset') ? 'block' : 'none'"
      >
        <mat-list-item role="listitem">
          <div>
            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image">
                <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
      </div>
      } }
    </div>
  </ng-template>

  <ng-template #grpMyAudit>
    <div class="menu-group">
      @if (!menuVisibility()['audit'].hiddenGroup) {
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
        <mat-list-item
          role="listitem"
          (click)="toggleVisibility('audit')"
          class="compliance-parent"
        >
          @if (collapsed()) {
          <div class="align-items group-icon" title="myAudit">
            <mat-icon class="icon material-symbols-rounded">{{ groupIcon('myAudit') }}</mat-icon>
          </div>
          } @else {
          <div class="align-items">
            <span class="parent-width">myAudit</span>
            <mat-icon
              class="expand-button"
              [ngClass]="{ rotated: menuVisibility()['audit'].menu }"
              >expand_more</mat-icon
            >
          </div>
          }
        </mat-list-item>
      }
      @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'AUDIT'){
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('audit') }"
        [style.display]="submenuVisible('audit') ? 'block' : 'none'"
      >
        <mat-list-item role="listitem">
          <div>
            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image">
                <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
      </div>
      } }
    </div>
  </ng-template>

  <ng-template #grpAdmin>
    <div class="menu-group">
      @if (!menuVisibility()['admin'].hiddenGroup) {
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
      <mat-list-item
        role="listitem"
        (click)="toggleVisibility('admin')"
        class="compliance-parent"
      >
        @if (collapsed()) {
        <div class="align-items group-icon" title="admin">
          <mat-icon class="icon material-symbols-rounded">{{ groupIcon('admin') }}</mat-icon>
        </div>
        } @else {
        <div class="align-items">
          <span class="parent-width">admin</span>
          <mat-icon
            class="expand-button"
            [ngClass]="{ rotated: menuVisibility()['admin'].menu }"
            >expand_more</mat-icon
          >
        </div>
        }
      </mat-list-item>
      }
      @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'ADMIN'){
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('admin') }"
        [style.display]="submenuVisible('admin') ? 'block' : 'none'"
      >
        <mat-list-item role="listitem">
          <div>
            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image">
                <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
      </div>
      } }
    </div>
  </ng-template>

  <ng-template #grpSystem>
    <div class="menu-group">
      @if (!menuVisibility()['system'].hiddenGroup) {
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
      <mat-list-item
        role="listitem"
        (click)="toggleVisibility('system')"
        class="compliance-parent"
      >
        @if (collapsed()) {
        <div class="align-items group-icon" title="system">
          <mat-icon class="icon material-symbols-rounded">{{ groupIcon('system') }}</mat-icon>
        </div>
        } @else {
        <div class="align-items">
          <span class="parent-width">system</span>
          <mat-icon
            class="expand-button"
            [ngClass]="{ rotated: menuVisibility()['system'].menu }"
            >expand_more</mat-icon
          >
        </div>
        }
      </mat-list-item>
      }
      @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'SYSTEM'){
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('system') }"
        [style.display]="submenuVisible('system') ? 'block' : 'none'"
      >
        <mat-list-item role="listitem">
          <div>
            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image">
                <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
      </div>
      } }
    </div>
  </ng-template>

  <ng-template #grpReports>
    <div class="menu-group">
      @if (!menuVisibility()['report'].hiddenGroup) {
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
      <mat-list-item
        role="listitem"
        (click)="toggleVisibility('report')"
        class="compliance-parent"
      >
        @if (collapsed()) {
        <div class="align-items group-icon" title="reports">
          <mat-icon class="icon material-symbols-rounded">{{ groupIcon('reports') }}</mat-icon>
        </div>
        } @else {
        <div class="align-items">
          <span class="parent-width">reports</span>
          <mat-icon
            class="expand-button"
            [ngClass]="{ rotated: menuVisibility()['report'].menu }"
            >expand_more</mat-icon
          >
        </div>
        }
      </mat-list-item>
      }
      @for(item of visibleNavItems(); track $index){ @if(item.moduleCategory ===
      'REPORTS'){
      <div
        class="submenu"
        [ngClass]="{ expanded: submenuExpanded('report') }"
        [style.display]="submenuVisible('report') ? 'block' : 'none'"
      >
        <mat-list-item role="listitem">
          <div class="report-row">

            @if (item.link.includes('saved/') && !collapsed()) {
            <mat-icon (click)="removeFavorite(item, $event)"
                      class="remove-icon"
                      title="Remove from sidebar">
                do_not_disturb_on
            </mat-icon>
            }

            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              class="report-link"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image" style="margin-left: 0;">
                @if (item.matIconName) {
                  <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                }
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
      </div>
      } }
    </div>
  </ng-template>

  <!-- Per-org custom menu group (context = the group view). -->
  <ng-template #grpCustom let-group>
    <div class="menu-group">
      <div class="menu-divider">
        <mat-divider style="width: 80%"></mat-divider>
      </div>
      <mat-list-item
        role="listitem"
        (click)="toggleCustomMenu(group.menu.key)"
        class="compliance-parent"
      >
        @if (collapsed()) {
        <div class="align-items group-icon" [attr.title]="group.menu.header">
          <!-- Custom menus carry their own curated icon, so no lookup needed. -->
          <mat-icon class="icon material-symbols-rounded">{{ group.menu.iconName }}</mat-icon>
        </div>
        } @else {
        <div class="align-items">
          <span class="parent-width">{{ group.menu.header }}</span>
          <mat-icon
            class="expand-button"
            [ngClass]="{ rotated: group.expanded }"
            >expand_more</mat-icon
          >
        </div>
        }
      </mat-list-item>
      <div
        class="submenu"
        [ngClass]="{ expanded: group.expanded }"
        [style.display]="group.expanded ? 'block' : 'none'"
      >
        @for (item of group.items; track $index) {
        <mat-list-item role="listitem">
          <div>
            <button
              mat-button
              data-cy="content"
              [routerLink]="item.link"
              routerLinkActive="active-route"
              [attr.title]="collapsed() ? item.text : null"
            >
              <div class="link-image">
                <mat-icon class="icon material-symbols-rounded">{{ item.matIconName }}</mat-icon>
                <span class="link-text">{{ item.text }}</span>
              </div>
            </button>
          </div>
        </mat-list-item>
        }
      </div>
    </div>
  </ng-template>

  @for (group of orderedGroups(); track group.key) {
    <ng-container
      [ngTemplateOutlet]="groupTemplate(group.key)"
      [ngTemplateOutletContext]="{ $implicit: group.custom }"
    />
  }
</mat-list>
